import type { CloudflareApplication } from "./types";

export function readCloudflareAssignmentIsLive(candidate: Record<string, unknown>): boolean {
  if (candidate.isLive === true || candidate.is_live === true) return true;
  if (candidate.isLive === false || candidate.is_live === false) return false;
  return false;
}

export function parseCloudflareApplicationsFromAuth(raw: unknown): CloudflareApplication[] {
  if (!Array.isArray(raw)) return [];

  return raw
    .map((entry) => {
      if (!entry || typeof entry !== "object") return null;
      const candidate = entry as Record<string, unknown>;
      const id = typeof candidate.id === "string" ? candidate.id : "";
      const tab = typeof candidate.tab === "string" ? candidate.tab : "";
      const subTab =
        typeof candidate.subTab === "string"
          ? candidate.subTab
          : typeof candidate.sub_tab === "string"
            ? candidate.sub_tab
            : "";
      const url = typeof candidate.url === "string" ? candidate.url.trim() : "";
      if (!id || !tab || !subTab) return null;
      return { id, tab, subTab, url, isLive: readCloudflareAssignmentIsLive(candidate) };
    })
    .filter((entry): entry is CloudflareApplication => entry !== null);
}
